import { render, staticRenderFns } from "./NotificationsItem.vue?vue&type=template&id=b1024f30&scoped=true&"
import script from "./NotificationsItem.vue?vue&type=script&lang=js&"
export * from "./NotificationsItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsItem.vue?vue&type=style&index=0&id=b1024f30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1024f30",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/bitrix/frontend/components/other/Button.vue').default,MtModal: require('/home/bitrix/frontend/components/Modal/MtModal.vue').default})
